import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/react-hooks';
import { Accordion, Card, Container, Row, Col } from 'react-bootstrap';

import * as S from './styles';

import { Loading, BreadCrumb } from '@atoms';
import { NoResult } from '@molecules';

import { FAQ_CATEGORY } from '@components/pages/FaqPage/queries';
import { faqCategory } from '@components/pages/FaqPage/__generated__/faqCategory';
import { faqUrl } from '@src/app/routes';

const FaqTopicPage = () => {
  const { topicId } = useParams();

  const { data, loading } = useQuery<faqCategory>(FAQ_CATEGORY, {
    variables: {
      id: topicId,
    },
  });

  const breadCrumbData = [
    {
      name: 'FAQ',
      link: faqUrl,
    },
    {
      name: 'TOPIC',
    },
  ];

  if (loading) {
    return <Loading />;
  }

  return data?.faqCategory?.topics?.length > 0 ? (
    <Container>
      <BreadCrumb data={breadCrumbData} />
      <Row>
        <Col>
          <Accordion defaultActiveKey="0">
            {data?.faqCategory?.topics?.map((topic, j) => {
              return (
                <Card key={topic.id}>
                  <S.FaqTopicCardHeader>
                    <S.FaqTopicAccordionToggle eventKey={j.toString()}>{topic.title}</S.FaqTopicAccordionToggle>
                  </S.FaqTopicCardHeader>
                  <Accordion.Collapse eventKey={j.toString()}>
                    <Card.Body>
                      <div dangerouslySetInnerHTML={{ __html: topic.content }}></div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              );
            })}
          </Accordion>
        </Col>
      </Row>
    </Container>
  ) : (
    <NoResult />
  );
};

export { FaqTopicPage };
